import IDVQuestionsContainer from './IDVQuestionsContainer';

export default IDVQuestionsContainer;
